module.exports = __webpack_public_path__ + "static/media/fabric_logo_hd.87c5bb71.png";